import { useTranslation } from 'react-i18next';

import { useTheme } from '../features/theme/ThemeProvider';
import type { Theme } from '../features/theme/ThemeProvider';
import type { IconName } from './Icon';
import { Icon } from './Icon';
import styles from './ThemeSwitcher.module.scss';

type ThemeOption = {
  readonly value: Theme;
  readonly icon: IconName;
  readonly labelKey: string;
};

const options: readonly ThemeOption[] = [
  { value: 'light', icon: 'sun', labelKey: 'theme.light' },
  { value: 'dark', icon: 'moon', labelKey: 'theme.dark' },
];

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <div className={styles.switcher}>
      <div className={styles.pills}>
        {options.map((option) => {
          const active = theme === option.value;
          const label = t(option.labelKey);
          return (
            <button
              key={option.value}
              type="button"
              className={`${styles.option} ${active ? styles.active : ''}`}
              aria-label={label}
              aria-pressed={active}
              onClick={() => setTheme(option.value)}
            >
              <Icon name={option.icon} size={16} />
              <span className={styles.optionLabel}>{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
